import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=cb3d0b1a"
import script from "./EmailConfirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailConfirmation.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports